import React, { useEffect, useState } from 'react';
import ConfirmForm from '../components/MemberRegistrationConfirmForm';
import { memberService } from '../services/memberService';
import CustomButtons from '../components/CustomButtons';
import { useNavigate } from 'react-router-dom';
import adminStyles from '../assets/css/member-registration.module.css';



function MemberRegistrationConfirmMyPage() {
  const [formData, setFormData] = useState(null);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [error, setError] = useState('');
  const navigate = useNavigate();

useEffect(() => {
  const getMyRegistrationData = async () => {
    try {
      const data = await memberService.getRegistration();
      setFormData(data.formData || {});
      setFamilyMembers(data.familyMembers || []);

    } catch (error) {
      console.error('登録情報の取得失敗:', error);
      setError('登録情報の取得に失敗しました');
    }
  };

  getMyRegistrationData();
}, []);

  if (error) return <p>{error}</p>;
  if (!formData) return <p>読み込み中...</p>;

  return (
  <div className={adminStyles.mainContents}>
    <div className={adminStyles.container}>
      <ConfirmForm formData={formData} familyMembers={familyMembers} />

        <CustomButtons
          leftLabel="戻る"
          rightLabel="編集する"
          onLeftClick={() => window.history.back()}
          onRightClick={() =>
                    navigate('/edit-member-registration', {
                      state: {
                        formData,
                        familyMembers
                      }
                    })
                  }
        />
    </div>
  </div>
  );
}

export default MemberRegistrationConfirmMyPage;